export const DEBOUNCE_DELAY = 300;
export const DEFAULT_ROWS_PER_PAGE = 20;
export const DEFAULT_ROWS_PER_PAGE_MODAL = 10;
export const BULK_SELECTION_LIMIT = 10;
